import React from "react";
import {
  Building2,
  HeartPulse,
  GraduationCap,
  BedDouble,
  Globe2,
  Trophy,
} from "lucide-react";

const SECTORS = [
  { id: "corporates", num: "01", title: "Corporates & Startups", Icon: Building2 },
  { id: "healthcare", num: "02", title: "Healthcare", Icon: HeartPulse },
  { id: "education", num: "03", title: "Educational Institutions", Icon: GraduationCap },
  { id: "hostels-pg", num: "04", title: "Hostels & PG Chains", Icon: BedDouble },
  { id: "gcc", num: "05", title: "GCC", Icon: Globe2 },
  { id: "sports-leisure", num: "06", title: "Sports & Leisure", Icon: Trophy },
];

export default function Sectors() {
  return (
    <section
      id="sectors"
      data-testid="sectors-section"
      className="py-28 md:py-36 bg-[#FDFBF7]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-16">
        <div className="grid grid-cols-12 gap-x-4 gap-y-10 md:gap-10 mb-16 md:mb-20">
          <div className="col-span-12 lg:col-span-5">
            <p className="label-eyebrow">04 · Sectors We Serve</p>
            <h2 className="font-serif text-[#1E3A5F] mt-5 text-4xl md:text-5xl lg:text-6xl leading-[1.02]">
              Built for the
              <br />
              <span className="italic text-[#CBA365]">places</span> Bengaluru
              <br />
              eats at.
            </h2>
          </div>
          <p className="col-span-12 lg:col-span-6 lg:col-start-7 text-[#1E3A5F]/70 font-light text-base md:text-[17px] leading-relaxed self-end">
            From boardrooms to hospital wards, from university campuses to
            global capability centres — we tailor every programme to the
            rhythm, compliance and culture of the room we serve.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 gap-px bg-[#1E3A5F]/10 border border-[#1E3A5F]/10">
          {SECTORS.map((s) => {
            const Icon = s.Icon;
            return (
              <div
                key={s.id}
                data-testid={`sector-tile-${s.id}`}
                className="group relative bg-[#FDFBF7] p-8 md:p-10 aspect-[5/4] md:aspect-[6/5] flex flex-col justify-between transition-colors duration-500 hover:bg-[#1E3A5F]"
              >
                <div className="flex items-center justify-between">
                  <span className="text-[10px] uppercase tracking-[0.28em] text-[#1E3A5F]/50 group-hover:text-[#CBA365] transition-colors">
                    {s.num}
                  </span>
                  <Icon
                    size={28}
                    strokeWidth={1.25}
                    className="text-[#1E3A5F] group-hover:text-[#CBA365] transition-colors"
                    aria-hidden="true"
                  />
                </div>
                <h3 className="font-serif text-[#1E3A5F] group-hover:text-[#FDFBF7] text-2xl md:text-3xl leading-snug transition-colors">
                  {s.title}
                </h3>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
